// ui
import { Box, Alert } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

// types
import type { ReactNode } from "react";

// ★cmd-po_1139: PoModalShell + PoButton で catalog 外殻を導入
import { PoModalShell } from "../common/PoModalShell";
import { PoButton } from "../common/PoButton";

export interface DataDeleteModalLabels {
  /** モーダルタイトル */
  title: string;
  /** 確認エリア（Alert ごと渡す。例: <Alert severity="error">〇〇後、データは復元できません。</Alert> または severity="info" の Alert） */
  confirmBody: ReactNode;
  /** 削除実行ボタンラベル */
  confirmButtonLabel: string;
  /** 成功時のメッセージ（例: "エントリーの削除に成功しました。"） */
  successMessage: string;
}

interface DataDeleteModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  deleteDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  };
  setDeleteDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }) => void;
  deleteData: () => void;
  /** 表示文言（呼び出し元で指定。未指定の場合は表示しない） */
  labels?: DataDeleteModalLabels;
}

export function DataDeleteModal(props: DataDeleteModalProps) {
  const {
    onModal,
    swCloseModal,
    deleteDataInf,
    setDeleteDataInf,
    deleteData,
    labels: labelsProp,
  } = props;
  const defaultLabels: DataDeleteModalLabels = {
    title: "",
    confirmBody: null,
    confirmButtonLabel: "",
    successMessage: "",
  };
  const labels: DataDeleteModalLabels = labelsProp ?? defaultLabels;
  const { title, confirmBody, confirmButtonLabel, successMessage } = labels;

  const footer =
    deleteDataInf.status === "open" ? (
      <>
        <PoButton
          variant="secondary"
          data-testid="data-delete-close-button"
          onClick={swCloseModal}
        >
          閉じる
        </PoButton>
        <PoButton
          variant="primary"
          data-testid="data-delete-execute-button"
          onClick={deleteData}
        >
          {confirmButtonLabel}
          <DeleteIcon fontSize="small" />
        </PoButton>
      </>
    ) : deleteDataInf.status === "success" ? (
      <PoButton
        variant="secondary"
        data-testid="data-delete-success-close-button"
        onClick={swCloseModal}
      >
        閉じる
      </PoButton>
    ) : deleteDataInf.status === "failed" ? (
      <PoButton
        variant="secondary"
        data-testid="data-delete-retry-button"
        onClick={() =>
          setDeleteDataInf({ ...deleteDataInf, status: "open", message: "" })
        }
      >
        戻る
      </PoButton>
    ) : null;

  return (
    <PoModalShell
      open={onModal}
      title={title}
      onClose={swCloseModal}
      testidPrefix="data-delete"
      footer={footer}
    >
      {deleteDataInf.status === "open" ? (
        <>{confirmBody}</>
      ) : deleteDataInf.status === "success" ? (
        <Box className="result-state -success" data-testid="result-state-success">
          <span className="rs-title">{successMessage}</span>
        </Box>
      ) : deleteDataInf.status === "failed" ? (
        <Box className="result-state -failed" data-testid="result-state-failed">
          <span className="rs-title">{deleteDataInf.message}</span>
        </Box>
      ) : null}
    </PoModalShell>
  );
}
